export const HELP_CENTER_PAGE_SIZE = 20;
export const EN_LANG_CODE = 'en_US';

export function buildHelpCenterPageParams(pageNo, pageSize = HELP_CENTER_PAGE_SIZE) {
  return { pageNo, pageSize };
}

export function emptyHelpCenterDetail(lang) {
  return { lang, title: '', body: '' };
}

export function mergeHelpCenterDetailsWithLanguages(languages, existingDetails = []) {
  const langEntries = [];
  const seen = new Set();

  (languages || []).forEach((lang) => {
    const code = lang.code || lang;
    if (!code || seen.has(code)) {
      return;
    }
    seen.add(code);
    langEntries.push({ code, label: lang.label || code });
  });

  (existingDetails || []).forEach((item) => {
    if (!item?.lang || seen.has(item.lang)) {
      return;
    }
    seen.add(item.lang);
    langEntries.push({ code: item.lang, label: item.lang });
  });

  const map = new Map((existingDetails || []).map((item) => [item.lang, { ...item }]));
  return langEntries.map(({ code, label }) => {
    const found = map.get(code);
    return found
      ? { ...found, lang: code, _label: label }
      : { ...emptyHelpCenterDetail(code), _label: label };
  });
}

export function stripHelpCenterDetails(details) {
  return (details || []).map(({ lang, title, body }) => ({
    lang,
    title: title || '',
    body: body || '',
  }));
}
